import { type ReactNode } from "react";
import { styled } from "@pigment-css/react";
import { BottomNavShell } from "@acto/taskpane/field-sales-2/components/patterns/BottomNav/BottomNavShell";
import { ChatInput, IDLE_HEIGHT_PX } from "./ChatInput";

const Slot = styled("div")({
  width: "100%",
  maxWidth: "800px",
});

/** The field grows upward out of flow. This slot holds the idle height so nothing below it moves. */
const FieldSlot = styled(Slot)({
  position: "relative",
  minHeight: `${IDLE_HEIGHT_PX}px`,
});

const FieldAnchor = styled("div")({
  position: "absolute",
  left: 0,
  right: 0,
  bottom: 0,
});

interface ChatInputDockProps {
  value: string;
  placeholder: string;
  loading?: boolean;
  notice?: ReactNode;
  onChange: (value: string) => void;
  onSend: () => void;
  onAbort?: () => void;
}

/**
 * Bottom input dock for the chat page. Reuses BottomNavShell so the gradient fade
 * and the `--bottom-nav-opaque-height` CSS var (which the message list pads by) match
 * the rest of field-sales-2's bottom navigation exactly.
 */
export function ChatInputDock({ value, placeholder, loading, notice, onChange, onSend, onAbort }: ChatInputDockProps) {
  return (
    <BottomNavShell>
      {notice && <Slot>{notice}</Slot>}
      <FieldSlot>
        <FieldAnchor>
          <ChatInput
            value={value}
            placeholder={placeholder}
            loading={loading}
            onChange={onChange}
            onSend={onSend}
            onAbort={onAbort}
          />
        </FieldAnchor>
      </FieldSlot>
    </BottomNavShell>
  );
}
